export const NO_STYLE_PRESET_CLASSNAME = 'no-style-preset';
